import {
  initialState,
  Actions,
  State,
  CHANGE_USERNAME,
  CHANGE_USERNAME_SUCCESS,
  CHANGE_USERNAME_ERROR,
  RESET_CHANGE_USERNAME,
} from "../../types/user/change-username";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case CHANGE_USERNAME:
      return {
        ...state,
        states: {
          success: false,
          loading: true,
          error: false,
        },
      };
    case CHANGE_USERNAME_SUCCESS:
      return {
        ...state,
        states: {
          success: true,
          loading: false,
          error: false,
        },
      };
    case CHANGE_USERNAME_ERROR:
      return {
        ...state,
        states: {
          success: false,
          loading: false,
          error: action.payload,
        },
      };
    case RESET_CHANGE_USERNAME:
      return {
        ...state,
        states: {
          success: false,
          loading: false,
          error: false,
        },
      };
    default:
      return state;
  }
};

export default reducers;
